const ISO_DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;
const US_DATE = /^(\d{1,2})\/(\d{1,2})\/(\d{2,4})$/;

const pad2 = (value) => String(value).padStart(2, '0');

export function parseDisplayDate(value) {
  if (value == null || value === '') return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  const raw = String(value).trim();
  if (!raw) return null;

  const isoDate = raw.match(ISO_DATE_ONLY);
  if (isoDate) {
    const year = Number(isoDate[1]);
    const month = Number(isoDate[2]);
    const day = Number(isoDate[3]);
    const parsed = new Date(year, month - 1, day);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  const usDate = raw.match(US_DATE);
  if (usDate) {
    const month = Number(usDate[1]);
    const day = Number(usDate[2]);
    let year = Number(usDate[3]);
    if (year < 100) year += year >= 70 ? 1900 : 2000;
    const parsed = new Date(year, month - 1, day);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  const parsed = new Date(raw);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function formatDateMdY(value, fallback = '-') {
  const parsed = parseDisplayDate(value);
  if (!parsed) return value ? String(value) : fallback;
  return `${pad2(parsed.getMonth() + 1)}/${pad2(parsed.getDate())}/${parsed.getFullYear()}`;
}

export function formatDateTimeMdY(value, fallback = '-') {
  if (typeof value === 'string' && ISO_DATE_ONLY.test(value.trim())) {
    return formatDateMdY(value, fallback);
  }
  const parsed = parseDisplayDate(value);
  if (!parsed) return value ? String(value) : fallback;
  let hours = parsed.getHours();
  const minutes = pad2(parsed.getMinutes());
  const suffix = hours >= 12 ? 'PM' : 'AM';
  hours %= 12;
  if (hours === 0) hours = 12;
  return `${formatDateMdY(parsed, fallback)} ${hours}:${minutes} ${suffix}`;
}

export function formatMonthYearMdY(value, fallback = '-') {
  const parsed = parseDisplayDate(value);
  if (!parsed) return value ? String(value) : fallback;
  return `${pad2(parsed.getMonth() + 1)}/${parsed.getFullYear()}`;
}
